import { intl } from "LocaleWrapper";
import { Table } from "@cofano/cck";
import { DataFormat } from "imports/Utils";
import { GeneralStaffelItemFragment } from "__generated__/view/staffels/graphql/staffel.fragments.generated";

const FeetStaffelItemsTable = ({
	content,
	contentLoading,
}: {
	content: GeneralStaffelItemFragment[];
	contentLoading?: boolean;
}) => (
	<Table
		id="feetStaffelTable"
		content={content}
		contentLoading={contentLoading}
		columns={[ {
			id: "startFeet",
			title: intl.formatMessage({ id: "FEET_START" }),
			render: (row: GeneralStaffelItemFragment) => DataFormat.simpleUnit("startFeet" in row ? row.startFeet : 0, DataFormat.UNITS.FEET),
		}, {
			id: "endFeet",
			title: intl.formatMessage({ id: "FEET_END" }),
			render: (row: GeneralStaffelItemFragment) => DataFormat.simpleUnit("endFeet" in row ? row.endFeet : 0, DataFormat.UNITS.FEET),
		}, {
			id: "price",
			title: intl.formatMessage({ id: "PRICE" }),
			render: (row: GeneralStaffelItemFragment) => DataFormat.price("price" in row ? row.price : undefined),
		}, {
			id: "reefer",
			title: intl.formatMessage({ id: "REEFER" }),
			render: (row: GeneralStaffelItemFragment) => DataFormat.boolean("reefer" in row ? row.reefer : undefined),
		}, {
			id: "empy",
			title: intl.formatMessage({ id: "EMPTY" }),
			render: (row: GeneralStaffelItemFragment) => DataFormat.boolean("empty" in row ? row.empty : undefined),
		} ]}
		disableFooter />
);

export default FeetStaffelItemsTable;
